import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
import { computed, ref, toRaw } from 'vue';
import MgMenuItem from './mg-menu-item.vue';
export default {
  __name: 'mg-sub-menu',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['itemClick', 'itemMouseenter', 'itemMouseleave'],
  setup(__props, {
    emit: __emit
  }) {
    const selectItem = ref();
    const props = __props;
    const emit = __emit;
    const subMenuClass = computed(() => {
      return {
        'vxe-table--context-menu-clild-wrapper': true,
        'is--show': props.show
      };
    });
    const isActiveItem = computed(() => item => {
      return item === toRaw(selectItem.value);
    });
    const handleItemMouseenter = ({
      item,
      $event
    }) => {
      selectItem.value = item;
      emit('itemMouseenter', {
        item,
        $event
      });
    };
    const handleItemMouseleave = ({
      item,
      $event
    }) => {
      emit('itemMouseleave', {
        item,
        $event
      });
      if (!item) {
        selectItem.value = null;
        return;
      }
      if (!!item.children && item.children.length > 0) {
        return;
      }
      selectItem.value = null;
    };
    const handleItemClick = ({
      item,
      $event
    }) => {
      emit('itemClick', {
        item,
        $event
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("ul", {
        class: _normalizeClass(subMenuClass.value)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, subIdx) => {
        return _renderSlot(_ctx.$slots, "default", {
          item: item,
          itemIndex: subIdx
        }, () => [(_openBlock(), _createBlock(MgMenuItem, {
          key: item.name || `sub_item${subIdx}`,
          data: item,
          active: isActiveItem.value(item),
          onMouseenter: handleItemMouseenter,
          onMouseleave: handleItemMouseleave,
          onClick: handleItemClick
        }, null, 8, ["data", "active"]))]);
      }), 256))], 2);
    };
  }
};